import './index.css';
import fotos from '../../mocks/database.js';

const foto = (p) => {
	const ft = fotos.find((e) => e.produto === p.produto);
	if (ft) return ft.foto;
};

const Finder = ({ produtos, closeModal, id }) => {
	const p = produtos.find((e) => e._id === id);
	return (
		<div className='ProdutoListaItem Finder'>
			<div>
				<h2> {p.produto} </h2>
				<p> {p.descricao} </p>
				<div>
					<span> R$ {p.preco} </span>
				</div>
			</div>
			<img className='ProdutoListaItem__foto' src={foto(p)} alt={p.produto} />
		</div>
	);
};

export default Finder;
